import api from '@/services/api'
import AutomationActions from './actions-types'
import AutomationMutations from './mutations-types'

export default {
  async [AutomationActions.GET_AUTOMATION_TRIGGERS]({ commit }) {
    const response = await api.node.automation.getAutomationTriggers()
    commit(AutomationMutations.SET_AUTOMATION_TRIGGERS, response.data)
    return response.data
  },

  [AutomationActions.GET_ALL_AUTOMATIONS]({}, options) {
    return new Promise((resolve, reject) => {
      api.node.automation
        .getAllAutomations(options)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [AutomationActions.GET_AUTOMATION]({}, automationId) {
    return new Promise((resolve, reject) => {
      api.node.automation
        .getAutomation(automationId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [AutomationActions.SAVE_AUTOMATION]({ state }, isMaster) {
    return new Promise((resolve, reject) => {
      let data = {}
      state.fields.forEach((item) => {
        // Omit an unspecified status so updates preserve the current value.
        if (item.name === 'active' && (item.value === null || item.value === undefined)) {
          return
        }

        // Ensure fixed_param is not null or empty
        if (item.name === 'fixed_param' && (item.value === null || item.value === '')) {
          data[item.name] = '{}';
        } else {
          data[item.name] = item.value;
        }
      })
      
      if (isMaster && data.tenant_id !== null) {
        return reject({ message: 'User Master can only create automations with null tenant_id' });
      } else if (!isMaster && data.tenant_id === null) {
        return reject({ message: 'User Admin can only create automations with non-null tenant_id' });
      }

      if (state.selectedAutomation) {
        const originalTenantId = state.selectedAutomation.tenant_id;
        const newTenantId = data.tenant_id;
        
        if (isMaster && (originalTenantId !== null || newTenantId !== null)) {
          return reject({ message: 'User Master can only edit automations with null tenant_id and cannot assign tenant' });
        }
        
        if (!isMaster && (originalTenantId === null || newTenantId === null)) {
          return reject({ message: 'User Admin can only edit automations with non-null tenant_id and must assign a tenant' });
        }
        
        api.node.automation
          .updateAutomation(data, state.selectedAutomation.automation_id)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      } else {
        api.node.automation
          .createAutomation(data)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      }
    })
  },

  [AutomationActions.UPDATE_AUTOMATION]({ state }, params) {
    const automation = state.selectedAutomation;
    const data = {
      pipeline_id: automation.pipeline_id,
      automation_trigger: automation.automation_trigger,
      fixed_param: automation.fixed_param,
      ...params.data
    };
    const isMaster = params.isMaster;

    // Ensure fixed_param is not null or empty
    if (data.fixed_param === null || data.fixed_param === '') {
      data.fixed_param = '{}';
    }

    
    return new Promise((resolve, reject) => {
      if (isMaster && state.selectedAutomation.tenant_id !== null) {
        return reject({ message: 'User Master can only edit automations with null tenant_id' });
      } else if (!isMaster && state.selectedAutomation.tenant_id === null) {
        return reject({ message: 'User Admin can only edit automations with non-null tenant_id' });
      }
      
      api.node.automation
        .updateAutomation(data, state.selectedAutomation.automation_id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  },

  [AutomationActions.GET_AUTOMATIONS_BY_NODE]({}, nodeId) {
    return new Promise((resolve, reject) => {
      api.node.automation
        .getAutomationsByNode(nodeId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [AutomationActions.ADD_AUTOMATION_NODE_RELATIONSHIP]({}, params) {
    return new Promise((resolve, reject) => {
      api.node.aspect
        .addAspectNodeRelationship(params.automationId, params.nodeId, params.data)
        .then(() => {
          resolve()
        })
        .catch(() => reject())
    })
  },

  [AutomationActions.REMOVE_AUTOMATION_NODE_RELATIONSHIP]({}, params) {
    return new Promise((resolve, reject) => {
      api.node.aspect
        .removeAspectNodeRelationship(params.automationId, params.nodeId)
        .then(() => {
          resolve()
        })
        .catch(() => reject())
    })
  },

  [AutomationActions.DELETE_AUTOMATION]({}, params) {
    return new Promise((resolve, reject) => {
      // First get the automation to check tenant_id
      api.node.automation
        .getAutomation(params.automationId)
        .then((response) => {
          const automation = response.data;
          const isMaster = params.isMaster;
          
          // Check if user has permission to delete this automation based on tenant_id
          if (isMaster && automation.tenant_id !== null) {
            return reject({ message: 'User Master can only delete automations with null tenant_id' });
          } else if (!isMaster && automation.tenant_id === null) {
            return reject({ message: 'User Admin can only delete automations with non-null tenant_id' });
          }
          
          // If permission check passes, proceed with deletion
          api.node.automation
            .deleteAutomation(params.automationId)
            .then((response) => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error.response ? error.response.data : error)
            })
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  }
}
